'use client';

import { Link } from '@mui/material';

export const CitationRefLink = ({ citationNumber, id }: { citationNumber: number; id: string }) => {
  return (
    <Link
      href={`#citation-ref-${id}`}
      sx={{ width: '2.75rem', pl: 2, flexShrink: 0 }}
      onClick={e => {
        e.preventDefault();
        window.history.pushState(null, '', `#citation-ref-${id}`);
        const citationRef = document.getElementById(`citation-ref-${id}`);
        if (citationRef) {
          citationRef.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      }}
    >
      {citationNumber}.
    </Link>
  );
};
